<template>
  <div class="about">
    <div class="banner">
      <img class="bg"
           src="https://lambor.oss-cn-shenzhen.aliyuncs.com/banner_about.png" />
      <div class="w"
           style="width: 1170px;">
        <h1>请供应链顾问</h1>
        <p>就找海平老师!</p>

      </div>
    </div>
    <div class="about_we">
      <div class="w"
           style="max-width: 1200px;">
        <h1 class="title">关于我们</h1>
        <p class="detail">
          海平创新成立于2016年，是一家专注为产融供应链(产业供应链+金融供应链）整体赋能的创新型知识科技公司，构建成了“创新产融社交+创新产融方案+创新产融科技+创新服务”的4S架构体系，并完全跑通了商业模式。
        </p>

        <ul>
          <li>行业首创“1+3+1：产业+产融平台（科技+数据+创新服务）+金融”架构</li>
          <li>实战专著【中国供应链第一神图】，累计销售超过10000份</li>
          <li>已经连续成功举办2届“中国产融供应链精英峰会”，现场参会者600+</li>
          <li>已帮助50+大中创新企业提供“产业互联网+供应链”整体解决方案</li>
          <li>已经拥有产融供应链行业40000+专业粉丝用户</li>
          <li>已成功设计并开发国内领先产融供应链行业SaaS平台，多家企业已经成功应用</li>
        </ul>
        <div class="imgBx">
          <img class="car"
               src="https://lambor.oss-cn-shenzhen.aliyuncs.com/car.png">
        </div>
        <div class="list">
          <div class="item">
            <div class="item_title">社交社群</div>
            <div class="content_Bx">
              <p>Sociality</p>
              <p>知识平台、精英微信群、小程序、年度产融峰会、神图、沙龙、茶友会……多渠道沉淀优质资产。<br /></p>
            </div>
          </div>
          <div class="item">
            <div class="item_title">产融方案</div>
            <div class="content_Bx">
              <p>Solution</p>
              <p>战略规划-产业互联网顶层设计-IT平台建设-供应链金融-增长运营-产融技营人才培养全链条的解决方案。</p>
            </div>
          </div>
          <div class="item">
            <div class="item_title">SaaS平台</div>
            <div class="content_Bx">
              <p>SaaS</p>
              <p>信息化战略规划、系统规划与设计数据规划、系统选型、IT监理、IT优化与评估等创新的SaaS服务。</p>
            </div>
          </div>
          <div class="item">
            <div class="item_title">创新服务</div>
            <div class="content_Bx">
              <p>Service</p>
              <p>创新增值服务：大核心人才团队的组建、供应链伯乐直推、国企并购供应链公司对接资金对接、专场培训</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="max-width: 1200px;margin: 20px auto 40px">
      <img width="100%" src="../assets/img/about/px.png" alt="" />
    </div>
    
    <!-- <div class="logoBx">
      <h1 class="title">与优秀的客户一起成长</h1>

      <p class="detail">
        我们已经累计服务超过50+客户：涵盖大型国企、上市公司、创新科技公司，传统产业龙头企业等，
        <br />
        已帮助超过国内5+大型国企、5+上市公司、30+创新平台/企业数字化转型

      </p>
      <div class="logo_list_box">
        <div class="w"
             style="width: 1170px;">
          <div class="left">
            <h6>
              大型国企/上市公司
            </h6>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/left1.png"
                   alt="">
            </div>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/left2.png"
                   alt="">
            </div>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/left3.png"
                   alt="">
            </div>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/left4.png"
                   alt="">
            </div>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/93840FA6A2ECF5F3.png"
                   alt="">
            </div>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/left6.png"
                   alt="">
            </div>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/left7.png"
                   alt="">
            </div>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/left8.png"
                   alt="">
            </div>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/left9.png"
                   alt="">
            </div>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/left10.png"
                   alt="">
            </div>
          </div>
          <div class="center">
            <div>
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/circle.png">
            </div>
          </div>
          <div class="right">
            <h6>
              创新科技平台/企业
            </h6>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/r1.png"
                   alt="">
            </div>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/r2.png"
                   alt="">
            </div>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/r3.png"
                   alt="">
            </div>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/r4.png"
                   alt="">
            </div>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/r5.png"
                   alt="">
            </div>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/r6.png"
                   alt="">
            </div>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/r7.png"
                   alt="">
            </div>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/r8.png"
                   alt="">
            </div>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/r9.png"
                   alt="">
            </div>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/r10.png"
                   alt="">
            </div>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/r11.png"
                   alt="">
            </div>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/r12.png"
                   alt="">
            </div>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/r13.png"
                   alt="">
            </div>
            <div class="item">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/r14.png"
                   alt="">
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'about'
}
</script>

<style lang="scss" scoped>
.about {
  background: #fff;
}
.w {
  max-width: 1440px;
  height: 100%;
  margin: 0 auto;
}
.banner {
  position: relative;
  width: 100%;
  min-height: 514px;
  display: block;
  overflow: hidden;
  background: #000;
}

.banner .w {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 100%;
  transform: translate(-50%, -50%);
}

.banner .w h1 {
  top: 152px;
  left: 662px;
}

.banner .w h1,
.banner .w p {
  font-size: 71px;
  font-family: 'huaweihongmengziti', FZZDHJW;
  font-weight: 400;
  color: #faebae;
  line-height: 41px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.53);
  position: absolute;
  white-space: nowrap;
}

.banner .w p {
  top: 272px;
  left: 777px;
}

.banner .bg {
  float: left;
  position: absolute;
  height: 100%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: opacity 0.17s ease;
}

.about_we {
  padding-top: 56px;
  padding-bottom: 52px;
}

.about_we ul {
  margin-top: 37px;
}

.about_we ul li {
  position: relative;
  font-size: 16px;
  font-weight: 700;
  color: #343434;
  line-height: 36px;
}

.about_we .imgBx {
  margin-top: 54px;
  text-align: center;
}

.about_we .list {
  overflow: hidden;
}

.about_we .list .item {
  position: relative;
  margin-top: 40px;
  margin-right: 35px;
  float: left;
  width: 266px;
  height: 262px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 20px;
  box-sizing: border-box;
}

.about_we .list .item .item_title {
  width: 266px;
  height: 68px;
  background: #f05923;
  border-radius: 20px 20px 0 0;
  font-size: 26px;
  font-weight: 700;
  color: #000;
  line-height: 68px;
  text-align: center;
}

.about_we .list .item .content_Bx {
  padding: 24px;
}

.w .list .item:before {
  content: "";
  position: absolute;
  left: 50%;
  top: -48px;
  transform: translateX(-50%);
  width: 6px;
  height: 60px;
  background: #f05923;
}

.w .list .item p:first-child {
  font-size: 20px;
  font-weight: 700;
  color: #f05923;
  line-height: 17px;
  text-align: center;
}

.w .list .item p:nth-child(2) {
  margin-top: 29px;
  width: 220px;
  height: 58px;
  font-size: 14px;
  font-weight: 400;
  color: #333;
  line-height: 22px;
}

.w .list .item:nth-child(4) {
  margin-right: 0;
}

.about_we ul li:before {
  content: "";
  position: absolute;
  left: -15px;
  top: 16px;
  width: 6px;
  height: 6px;
  background: #f05923;
  border-radius: 3px;
}

.title {
  font-size: 32px;
  line-height: 62px;
}

.detail,
.title {
  font-weight: 400;
  color: #343434;
  text-align: center;
}

.detail {
  font-size: 18px;
  line-height: 30px;
}

.logoBx {
  padding-top: 56px;
  min-height: 918px;
  background: #f0f2f5;
}

.logoBx .logo_list_box .w .left {
  margin-top: 130px;
}

.logoBx .logo_list_box .w .left .item {
  float: left;
  margin-left: 12px;
  margin-top: 30px;
  width: 166px;
  height: 56px;
  background: #fff;
  border: 1px solid #f05923;
  border-radius: 5px;
  line-height: 48px;
  text-align: center;
}

.logoBx .logo_list_box .w .center div {
  margin-top: 117px;
  width: 100%;
  text-align: center;
}

.logoBx .logo_list_box .w .right {
  margin-top: 20px;
}

.logoBx .logo_list_box .w .right .item {
  float: left;
  margin-left: 12px;
  margin-top: 30px;
  width: 166px;
  height: 56px;
  background: #fff;
  border: 1px solid #f05923;
  border-radius: 5px;
  line-height: 48px;
  text-align: center;
}

.logoBx .logo_list_box .w .left .item:nth-child(2n) {
  margin-right: 0;
}

.logoBx .logo_list_box .w .center,
.logoBx .logo_list_box .w .left,
.logoBx .logo_list_box .w .right {
  position: relative;
  float: left;
  margin-right: 15px;
  width: 32%;
}

.logoBx .logo_list_box .w .left h6,
.logoBx .logo_list_box .w .right h6 {
  position: absolute;
  bottom: -50px;
  left: 45%;
  transform: translateX(-50%);
  font-size: 24px;
  font-weight: 700;
  color: #000;
  line-height: 48px;
  margin: 0;
}
@media screen and (max-width: 1170px) {
  body,
  html {
    min-width: 1170px;
  }

  .nav .menu-list li {
    float: left;
    margin-left: 50px;
    font-size: 18px;
    height: 80px;
    color: #fff;
  }

  .banner .w h1 {
    top: 35%;
    left: 50%;
    transform: translate(-50%, -35%);
  }

  .banner .w h1,
  .banner .w p {
    font-weight: 500;
    position: absolute;
  }

  .banner .w p {
    top: 60%;
    left: 60%;
    transform: translate(-50%, -40%);
  }

  .about_we {
    padding: 50px 28px;
    overflow: hidden;
  }

  .about_we .detail {
    width: 90%;
  }

  .about_we .imgBx {
    transform: translateX(-40px);
  }

  .about_we .list .item {
    width: 245px;
  }

  .w .list .item:before {
    content: "";
    background: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/about.vue